import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=0f6ee4d4&scoped=true&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"
import style0 from "./upload.vue?vue&type=style&index=0&id=0f6ee4d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ee4d4",
  null
  
)

export default component.exports